import { PortfoliosVersionsService_portfolioVersionsServiceV3GetLatest } from '@festina/unitlink-general-types/unitlink/hooks/PortfoliosVersionsService_portfolioVersionsServiceV3GetLatest'

export const useFetchPortfolioVersionLatestNoSuspense =
  PortfoliosVersionsService_portfolioVersionsServiceV3GetLatest.useQuery
